(function($){

    jQuery('a').smoothScroll({offset: -160});

    if(window.location.hash) {
        var hash = window.location.hash;

        jQuery('html, body').animate({
            scrollTop: jQuery(hash).offset().top - 160
        }, 800, 'swing');
    }


    // Refresh JazzHR iframe with search parameters.
    if ( $('#resumator-job-frame').length ) {
        // Query string example.
        // State needs to be uppercase.
        // ?form_id=advanced_search_jobs&s_title=XXXXX&s_state=MN

        var loc        = window.location.href;
        var params     = loc.split('?')[1];
        var iframe     = document.getElementById('resumator-job-frame');
        var iframe_src = iframe.src;

        // Update iframe src with parameters.
        if ( params ) {

            let mnDept = [
                'West+Metro',
                'Central+Metro',
                'East+Metro',
                'South+Metro',
                'Greater+MN'
            ];

            mnDept.forEach((dept) => {
                if ( params.includes(dept)) {
                    params = params.replace('s_state', 's_keywords');
                }
            });

            console.log('darin');
            console.log(params);
            // Clear iframe source of any exising parameters, then append new params.
            iframe.src = iframe_src.split('?')[0] + '?' + params;

            // Scroll to iframe.
            $('html, body').animate({
                scrollTop: $(iframe).offset().top - 150
            }, 800, 'swing');

        }

        // Remove the query string from the browser URL.
        window.history.replaceState(null, null, window.location.pathname);
    }


    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    if ( $('#wpsl-wrap').length && getUrlParameter( 'wpsl-search-input') ) {

        // Foundation.SmoothScroll.scrollToLoc( $('#wpsl-gmap'), {
        //     threshold: 50,
        //     offset: 80
        // });

        // Scroll to map.
        $('html, body').animate({
            scrollTop: $('#wpsl-gmap').offset().top - 180
        }, 800, 'swing');


        $('#wpsl-search-input').val( getUrlParameter( 'wpsl-search-input') );
        $('#wpsl-category-list').val( getUrlParameter( 'wpsl-category') );

        // Remove the query string from the browser URL.
        window.history.replaceState(null, null, window.location.pathname);

        $(window).bind('load', function() {
           $('#wpsl-search-btn').trigger( 'click' );
        });

    }

})(jQuery);
